import { FC } from 'react';
import { ProjectTabProps } from './ProjectTabProps';
import { ESTABLISHMENT_TYPE } from '../ProjectTypeSelect/utils';
import NewUnitProjectForm from './NewUnitProjectForm';
import ImproveProjectForm from './ImproveProjectForm';
import ProjectForm from './ProjectForm';
import FormatChangeProjectForm from './FormatChangeProjectForm';
import CloseProjectForm from './CloseProjectForm';

const ProjectTab: FC<ProjectTabProps> = ({
  tabType,
  projectList,
  isConfidentialAllowed,
  isep,
  programName,
  isRealEstateSisan,
}) => {
  switch (tabType) {
    case ESTABLISHMENT_TYPE.NEW_UNIT:
      return (
        <NewUnitProjectForm
          projectList={projectList}
          isConfidentialAllowed={isConfidentialAllowed}
          isep={isep}
        />
      );
    case ESTABLISHMENT_TYPE.IMPROVE:
      return (
        <ImproveProjectForm
          projectList={projectList}
          isConfidentialAllowed={isConfidentialAllowed}
          isep={isep}
          isRealEstateSisan={isRealEstateSisan}
          programName={programName}
        />
      );
    case ESTABLISHMENT_TYPE.FORMAT_CHANGE:
      return (
        <FormatChangeProjectForm
          projectList={projectList}
          isConfidentialAllowed={isConfidentialAllowed}
          isep={isep}
        />
      );
    case ESTABLISHMENT_TYPE.RELOCATION:
      return (
        <ProjectForm
          projectList={projectList}
          isConfidentialAllowed={isConfidentialAllowed}
          isep={isep}
        />
      );
    case ESTABLISHMENT_TYPE.CLOSE:
      return (
        <CloseProjectForm
          projectList={projectList}
          isConfidentialAllowed={isConfidentialAllowed}
          isep={isep}
        />
      );
  }
};

export default ProjectTab;
